import React from 'react'
import { OffsetKeys } from 'src/core/models'
import { useAppSelector } from 'src/app/hooks'
import styles from './OffsetPreparedMovileViewColumn.module.scss'
import { FormLabels, CustomText, PreviewExtraDataColumn } from 'src/components'
import { offsetByExcelSelector, offsetOptionalFieldsSelector } from 'src/features'

interface OffsetPreparedMovileViewColumnProps {
  data: object,
  keys: OffsetKeys,
  amount: string
}

const OffsetPreparedMovileViewColumn: React.FC<OffsetPreparedMovileViewColumnProps> = (props) => {
  const { data, keys, amount } = props
  const { use_company_name_in_offset } = useAppSelector(offsetOptionalFieldsSelector)
  const { offsetKeys: { co2UnitField } } = useAppSelector(offsetByExcelSelector)

  // Email
  const emailLabel = data[keys?.emailField]
  // Name
  const nameLabel = {
    NAME: `${data[keys?.nameField]} ${data[keys?.lastNameField]}`,
    COMPANY: data[keys?.companyNameField]
  }[use_company_name_in_offset ? 'COMPANY': 'NAME']
  // Contract
  const contractLabel = data[keys?.identifierField]
  // Emission
  const unit = { KG: 'kgCO2', TONS: 'tCO2' }[co2UnitField]
  const emissionLabel = `${amount} ${unit}`

  return <>
    <FormLabels
      title={emailLabel}
      subtitle={nameLabel}
      thirdLabel={contractLabel}
    />
    <div className={styles.actionsContent}>
      <CustomText label={emissionLabel} />
      <PreviewExtraDataColumn excelData={data} />
    </div>
  </>
}

export default OffsetPreparedMovileViewColumn
